import React, { useEffect, useCallback } from 'react'
import { toast } from 'react-toastify'; 
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import SideStyle from '../style/sideStyle';
import FormAlign_0 from './formAlign_0';
import FormAlign_1 from './formAlign_1';
import FormAlign_2 from './formAlign_2';
import FormAlign_3 from './formAlign_3';
import Param from '../store/param';
import Control from '../store/control';

/**
 * Renders a form based on the current step of the alignment process.
 * @returns {JSX.Element|string} The form component to render or a string indicating an unknown step.
 */
const Form = () => {
  const align    = Param.Get('align');

  switch (align.step) {
    case 0:
      return <FormAlign_0/>; // Angle
    case 1:
      return <FormAlign_1/>; // Ischium level
    case 2:
      return <FormAlign_2/>; // Bottom length
    case 3:
      return <FormAlign_3/>; // Greater trochanter
    default:
      return 'Unknown step';
  }
}

// Alignment
const FormAlign = () => {
  const style      = SideStyle();

  const SetCameraFront = Control.Get('SetCameraFront');
  const align      = Param.Get('align');
  const setParam   = Param.Get('setParam');
  
  useEffect(() => {
    toast.info('Set angle.', {autoClose: 500});
  }, [])
  
  const onClick = useCallback((val) => {
    setParam(s => {s.align.step = val});

    if (val==0) {
      toast.info('Set angle.', {autoClose: 500});
    } else if (val==1) {
      toast.info('Set Ischial level.', {autoClose: 500});
    } else if (val==2) {
      toast.info('Set bottom of stump.', {autoClose: 500});
    } else if (val==3) {
      toast.info('Set greater trochanter.', {autoClose: 500});
    }
  });

  /**
   * Returns the active button style based on the current step value.
   * @param {number} val - The step value to compare with the current step.
   * @returns {string} - The button style, either selected or unselected.
   */
  function getActive(val){
    return (align.step == val) 
      ? `${style.button} ${style.buttonSelected}`
      : style.button;
  }

  return (
    <div className={style.outside}>
      {/* Menu */}
      <Grid container spacing={1} alignItems='center'>
        <Grid item xs={3}>
          <Button name="step" className={getActive(0)} onClick={() => onClick(0)} >Angle</Button>
        </Grid>
        <Grid item xs={3}>
          <Button name="step" className={getActive(1)} onClick={() => onClick(1)} >Ischial level</Button>
        </Grid>
        <Grid item xs={3}>
          <Button name="step" className={getActive(2)} onClick={() => onClick(2)} >Stump length</Button>
        </Grid>
        <Grid item xs={3}>
          <Button name="step" className={getActive(3)} onClick={() => onClick(3)} >Greater trochanter</Button>
        </Grid>
      </Grid>
      <Box mb={1} />
      <Box borderBottom={1} style={{ borderBottom: '1px solid black' }} ></Box>
      <Box mb={3} />
      <Form/> 
    </div>
  );
}
export default FormAlign;
